import { Directive, ElementRef, Input } from '@angular/core';
import { TabId } from '../tab';

@Directive({
  selector: '[avanoTabLabelWrapper]'
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class TabLabelWrapper {
  @Input() id: TabId;
  @Input() label: string;
  @Input() leftIcon: string;
  @Input() closable = false;
  @Input() isLoading = false;
  @Input() isUnsaved = false;

  constructor(public elementRef: ElementRef) {}

  /** Sets focus on the wrapper element */
  focus(): void {
    this.elementRef.nativeElement.focus();
  }

  getOffsetLeft(): number {
    return this.elementRef.nativeElement.offsetLeft;
  }

  getOffsetWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }
}
